import { useSetting } from './useSetting';
import * as ViewModel from '@/core/presenter/viewModel/viewTypes';
import SettingViewHeader from './components/SettingViewHeader';
import MainView from './components/MainView';
import PwdSettingView from './components/PwdSettingView';
import CheckPwdSettingView from './components/CheckPwdSettingView';
import ExitView from './components/ExitView';
import FooterBar from '@/components/navbar/FooterBar';
import PinSettingView from './components/PinSettingView';
import { observer } from 'mobx-react-lite';

const Setting = observer(() => {
  const {
    isOpen,
    prePassword,
    settingViewType,
    isPrePasswordCheckedBtn,
    newPassword,
    confirmPassword,
    isNewPasswordValid,
    isNotMatchPassword,
    isCheckPasswordDisabled,
    isChecked,
    lastLoginTime,
    pin,
    isPinCheckFailed,
    pinStep,
    isNotMatchPin,
    isConfirmPasswordValid,
    onClickNumberBtn,
    OnClickDeleteBtn,
    onClickAllClearBtn,
    onChangeSettingViewType,
    onClickToggleBtn,
    onClickLogoutBtn,
    onChangePassword,
    onClickPwdNextBtn,
    onChangeNewPassword,
    onChangeConfirmPassword,
    onBlurNewPassword,
    onKeyDownCheckNewPassword,
    onClickCompleteBtn,
    onClickCheckbox,
    onClickWithdrawBtn,
    onMoveSettingMainView,
    onClickAddHomeBtn,
    onBlurPassword,
  } = useSetting();

  return (
    <div className="wrap wrap_temporary">
      {settingViewType === ViewModel.SettingViewType.MAIN && (
        <>
          <SettingViewHeader
            settingViewType={settingViewType}
            onChangeSettingViewType={onChangeSettingViewType}
            title="설정"
          />
          <MainView
            lastLoginTime={lastLoginTime ?? ''}
            isOpen={isOpen}
            onClickToggleBtn={onClickToggleBtn}
            onClickLogoutBtn={onClickLogoutBtn}
            onChangeSettingViewType={onChangeSettingViewType}
            onClickAddHomeBtn={onClickAddHomeBtn}
          />
        </>
      )}
      {settingViewType === ViewModel.SettingViewType.PWD_SETTING && (
        <>
          <SettingViewHeader
            settingViewType={settingViewType}
            onChangeSettingViewType={onChangeSettingViewType}
            title="비밀번호 재설정"
          />
          <PwdSettingView
            isPrePasswordCheckedBtn={isPrePasswordCheckedBtn}
            prePassword={prePassword}
            onChangePassword={onChangePassword}
            onClickPwdNextBtn={onClickPwdNextBtn}
          />
        </>
      )}
      {settingViewType === ViewModel.SettingViewType.CHECK_PWD_SETTING && (
        <>
          <SettingViewHeader
            settingViewType={settingViewType}
            onChangeSettingViewType={onChangeSettingViewType}
            title="비밀번호 재설정"
          />
          <CheckPwdSettingView
            newPassword={newPassword}
            confirmPassword={confirmPassword}
            isNewPasswordValid={isNewPasswordValid}
            isNotMatchPassword={isNotMatchPassword}
            isCheckPasswordDisabled={isCheckPasswordDisabled}
            isConfirmPasswordValid={isConfirmPasswordValid}
            onChangeNewPassword={onChangeNewPassword}
            onChangeConfirmPassword={onChangeConfirmPassword}
            onBlurNewPassword={onBlurNewPassword}
            onKeyDownCheckNewPassword={onKeyDownCheckNewPassword}
            onClickCompleteBtn={onClickCompleteBtn}
            onBlurPassword={onBlurPassword}
          />
        </>
      )}
      {settingViewType === ViewModel.SettingViewType.PIN_SETTING && (
        <>
          <PinSettingView
            pin={pin}
            isPinCheckFailed={isPinCheckFailed}
            pinStep={pinStep}
            isNotMatchPin={isNotMatchPin}
            onClickNumberBtn={onClickNumberBtn}
            OnClickDeleteBtn={OnClickDeleteBtn}
            onClickAllClearBtn={onClickAllClearBtn}
          />
        </>
      )}
      {settingViewType === ViewModel.SettingViewType.EXIT && (
        <>
          <SettingViewHeader
            settingViewType={settingViewType}
            onChangeSettingViewType={onChangeSettingViewType}
            title="회원탈퇴"
          />
          <ExitView isChecked={isChecked} onClickCheckbox={onClickCheckbox} onClickWithdrawBtn={onClickWithdrawBtn} />
        </>
      )}
      <FooterBar settingViewType={settingViewType} onMoveSettingMainView={onMoveSettingMainView} />
    </div>
  );
});

export default Setting;
